// import React from 'react';
import { styled } from '@mui/material/styles';
import { DualUseGoodsClobDto } from 'models/dtoTypes';
import SubSection from './_subSection';
import SdgScoreClob, { ISdgData } from './_sdgScoreClob';
import Empty from './_empty';
import { dualUseGoods } from 'kosmos/images';
import EsgLegand from './_esgLegand';
import { useTranslation } from 'react-i18next';

const PREFIX = '_dualUseGoodsReport';

const classes = {
  report: `${PREFIX}-report`,
};

const Root = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  [`& .${classes.report}`]: {},
}));

interface IProps {
  name?: string;
  dualUseGoodsReport: DualUseGoodsClobDto[];
}

export default function DualUseGoodsReport(props: IProps): JSX.Element {
  const { t } = useTranslation('default');
  const { name = t('dual-use-goods'), dualUseGoodsReport } = props;
  const renderSingleClob = (item: DualUseGoodsClobDto, index: number) => {
    const { entitySummaryCode, entitySummaryDetail, affinity } = item;
    const code: string = entitySummaryCode || t('unknown');
    const desc: string = entitySummaryDetail || t('unknown');
    const title = `${code} - ${desc}`;

    return (
      <SdgScoreClob withBorder={true} withBg={true} key={index} title={title} affinity={affinity} />
    );
  };

  const renderLegands = () => {
    const legands: ISdgData[] = [
      {
        affinity: 'negative',
        title: t('business-products-identified-as-used-for-military-purpose'),
        withBg: true,
        size: 'small',
      },
      {
        affinity: 'warning',
        title: t(
          'business-products-identified-as-a-dualuse-good-and-potentially-used-for-military-purpose',
        ),
        withBg: true,
        size: 'small',
      },
      {
        affinity: 'positive',
        title: t('business-products-identified-as-nondualuse-good'),
        withBg: true,
        size: 'small',
      },
    ];

    return (
      <EsgLegand
        legands={legands}
        title={t('activity-check-against-dualuse-goods-lists')}
        learnMoreTabId="dug"
      />
    );
  };

  const renderContent = () => {
    if (dualUseGoodsReport.length === 0) {
      return <Empty title={t('there-is-no-data-available')} />;
    }

    return <Root>{dualUseGoodsReport.map(renderSingleClob)}</Root>;
  };

  return (
    <SubSection title={name} isBold icon={<img src={dualUseGoods} />}>
      <>
        {renderLegands()}
        {renderContent()}
      </>
    </SubSection>
  );
}
